module.exports = __webpack_public_path__ + "img/paste.031aa90a.svg";